import { create } from 'zustand';
import { persist } from 'zustand/middleware';

export type NetworkMode = 'unconfigured' | 'cloud' | 'local_master' | 'local_client' | 'local';

interface NetworkState {
  mode: NetworkMode;
  localServerIp: string;
  setMode: (mode: NetworkMode) => void;
  setLocalServerIp: (ip: string) => void;
  getLocalApiUrl: () => string;
}

export const useNetworkStore = create<NetworkState>()(
  persist(
    (set, get) => {
      const isElectron = navigator.userAgent.toLowerCase().includes('electron');
      const initialMode = !isElectron 
        ? 'cloud' 
        : (localStorage.getItem('BRANCH_TOKEN') ? 'local' : 'unconfigured');

      return {
        mode: initialMode,
      localServerIp: '127.0.0.1',
      setMode: (mode) => set({ mode }),
      setLocalServerIp: (ip) => set({ localServerIp: ip }),
        getLocalApiUrl: () => {
          return 'http://127.0.0.1:4000/local-api';
        },
      };
    },
    {
      name: 'network-storage',
    }
  )
);
